// @ts-nocheck
import { FormFieldPresentationPropsCommon } from "@insite/mobius/FormField";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { linkActionStyles } from "@store/Themes/common/mixins/link";
import { inlineSeparatorStyles } from "@store/Themes/common/mixins/typography";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import updateCssValue, { Operators } from "@toolkit/Framework/Common/Utilities/updateCssValue";
import { gridGapStyles, gridPresetGapStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Foundation --> */
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import { GridItemProps } from "@insite/mobius/GridItem";
import parseNumber from "@toolkit/Framework/Common/Utilities/parseNumber";
/* <-- Foundation */

export interface FormGridProps {
    gridContainer: GridContainerProps;
    innerGridContainer: GridContainerProps;
    formField?: FormFieldPresentationPropsCommon;
    title?: TypographyPresentationProps;
    labelSeparated?: TypographyPresentationProps;
    labelLink?: LinkPresentationProps;
}

const sharedGridProps: Partial<FormGridProps> = {
    title: {
        variant: "h5",
        forwardAs: "h2",
        css: css`
            font-size: ${pxToRem(18)};
            margin-top: 1.2em;
        `,
    },
    labelSeparated: {
        css: inlineSeparatorStyles({
            spacing: pxToRem(16),
            width: pxToRem(1),
            color: "common.border",
        }),
    },
    labelLink: {
        css: css`
            ${linkActionStyles()}
            vertical-align: middle;
        `,
    },
};

export const formGridProps: FormGridProps = {
    ...sharedGridProps,
    gridContainer: {
        gap: 0,
        css: css`
            ${x => gridPresetGapStyles(x.theme.design.form.grid.base)}
        `,
    },
    innerGridContainer: {
        gap: 0,
        css: css`
            ${({ theme }) => {
                return gridGapStyles(
                    theme.design.form.grid.base.horizontal.map(x => updateCssValue(x, Operators.Divide, 2)),
                    theme.design.form.grid.base.vertical,
                );
            }}
        `,
    },
};

export const formSmallGridProps: FormGridProps = {
    ...sharedGridProps,
    gridContainer: {
        gap: 0,
        css: css`
            ${x => gridPresetGapStyles(x.theme.design.form.grid.small)}
        `,
    },
    innerGridContainer: {
        gap: 0,
        css: css`
            ${({ theme }) => {
                return gridGapStyles(
                    theme.design.form.grid.small.horizontal.map(x => updateCssValue(x, Operators.Divide, 2)),
                    theme.design.form.grid.small.vertical,
                );
            }}
        `,
    },
    formField: {
        sizeVariant: "small",
    },
};

/* Foundation --> */
export const formFieldSpacingStyles = () => css`
    ${contentSpacingStyles(null, null, pxToRem(16))}
`;

export const formNarrowGridProps: GridContainerProps = {
    gap: 0,
    css: css`
        ${({ theme }) => gridGapStyles([theme.design.form.actions.spacing])}
    `,
};

export const buttonSpacingForGridItem = css`
    ${({ theme }) =>
        updateCssValue(
            theme.design.form.actions.spacing,
            Operators.Substract,
            (parseNumber(theme.design.form.fields.spacing) ?? 0) / 2,
        )}
`;

export const formButtonGridItemProps: GridItemProps = {
    width: 12,
    css: css`
        padding-top: ${buttonSpacingForGridItem} !important; /* Required to override grid padding */
    `,
};

export const formFieldSizeVariants = {
    default: {
        borderRadius: 4,
        height: 48,
        fontSize: 16,
        icon: 18,
        iconPadding: 15,
        descriptionLineSpacing: 5,
    },
    small: {
        borderRadius: 3,
        height: 40,
        fontSize: 14,
        icon: 16,
        iconPadding: 12,
        descriptionLineSpacing: 5,
    },
};

export const formFieldBorderTypes = {
    error: {
        width: 2,
        borderPaddingRule: "",
        textAreaBorderPaddingRule: "",
    },
    focus: {
        width: 2,
        borderPaddingRule: "",
        textAreaBorderPaddingRule: "",
    },
    inactive: {
        width: 2,
        borderPaddingRule: "padding: 0 1em;",
        textAreaBorderPaddingRule: "padding: 1em;",
    },
};
/* <-- Foundation */
